import * as React from 'react';
import { SupportRequestTypes } from 'src/reducers/supportRequest';
import SupportPageView from '../layouts/SupportView';
// import { Snackbar } from '@material-ui/core';
// import { Alert, AlertTitle } from '@material-ui/lab';
// import MuiAlert, { AlertProps } from '@material-ui/lab/Alert';
// import { Snackbar } from '@material-ui/core';
// import { Alert, AlertTitle } from '@material-ui/lab';
// import MuiAlert, { AlertProps } from '@material-ui/lab/Alert';
// import Button from '@material-ui/core/Button';

// function Alert(props: AlertProps) {
//   return <MuiAlert elevation={6} variant="filled" {...props} />;
// }
export interface SupportPageViewProps {
  onComponentDidMount: () => void;
  onComponentWillMount: () => void;
  saveQueryType: (querytype: string) => void;
  saveMessages: (message: string) => void;
  saveAttachment: (attachment: string) => void;
  onSubmit: () => void;
  onFilesChange: (messageFiles: Array<File>) => void;
  onFilesError: (error: Error, images: Array<File>) => void;
  saveOrderNo: (orderno: string) => void;
  orderNo: string;
  queryType: string;
  orderDisabled: boolean;
  // errorfilemsg: string;
  // errorFileUploadedOpen: boolean;
  // successfilemsg: string;
  // successFileUploadOpen: boolean;
  // handleClose: () => void;

  message: string;
  ticketGen: string;
  messageFiles: Array<File>;
  supportRequestTypes: SupportRequestTypes[];
}

class SupportPage extends React.Component<SupportPageViewProps> {
  render() {
    return (
      <div>
        <SupportPageView
          saveQueryType={this.props.saveQueryType}
          saveMessages={this.props.saveMessages}
          saveAttachment={this.props.saveAttachment}
          onSubmit={this.props.onSubmit}
          onFilesChange={this.props.onFilesChange}
          onFilesError={this.props.onFilesError}
          orderDisabled={this.props.orderDisabled}
          message={this.props.message}
          queryType={this.props.queryType}
          ticketGen={this.props.ticketGen}
          saveOrderNo={this.props.saveOrderNo}
          orderNo={this.props.orderNo}
          messageFiles={this.props.messageFiles}
          supportRequestTypes={this.props.supportRequestTypes}
        />
        {/* <------------------------------------------------------Error Message---------------------------------> */}
        {/* <Snackbar
          open={this.props.errorFileUploadedOpen}
          autoHideDuration={3000}
          transitionDuration={1000}
          onClose={this.props.handleClose}
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'center',
          }}
        >
          <Alert
            severity="error"
            onClose={this.props.handleClose}
          >
            <AlertTitle>Error</AlertTitle>
            {this.props.errorfilemsg}
          </Alert>
        </Snackbar> */}
        {/* <------------------------------------------------------Success Message---------------------------------> */}
        {/* <Snackbar
          open={this.props.successFileUploadOpen}
          autoHideDuration={3000}
          transitionDuration={1000}
          onClose={this.props.handleClose}
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'center',
          }}
        >
          <Alert
            severity="success"
            onClose={this.props.handleClose}
          >
            <AlertTitle>Success</AlertTitle>
            {this.props.successfilemsg}
          </Alert>
        </Snackbar> */}
        {/* <Snackbar
          open={this.props.errorBar}
          autoHideDuration={2000}
          onClose={this.props.handleClose}
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'center',
          }}
        >
          <Alert
            severity="error"
          >
            <AlertTitle>Error</AlertTitle>
            {this.props.errorMessage}
          </Alert>
        </Snackbar>
        <Snackbar
          open={this.props.successBar}
          autoHideDuration={2000}
          onClose={this.props.handleClose}
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'center',
          }}
        >
          <Alert
            severity="success"
          >
            <AlertTitle>Success</AlertTitle>
            {this.props.successMessage}
          </Alert>
        </Snackbar> */}
      </div>
    );
  }
  componentDidMount() {
    this.props.onComponentDidMount();
  }
  componentWillMount() {
    // const url: string = window.location.href;
    this.props.onComponentWillMount();
}
}

export default SupportPage;



// WEBPACK FOOTER //
// ./src/components/support/SupportPage.tsx